import { ref } from 'vue';

export type ModalMode = 'create' | 'edit' | 'delete';

export function useModal<T = any>() {
    const isOpen = ref(false);
    const mode = ref<ModalMode>('create');
    const data = ref<T | null>(null);

    function open(modalMode: ModalMode, item?: T) {
        mode.value = modalMode;
        data.value = item ? { ...item } : null;
        isOpen.value = true;
    }

    function close() {
        isOpen.value = false;
        mode.value = 'create';
        data.value = null;
    }

    return {
        isOpen,
        mode,
        data,
        open,
        close
    };
}